import './helpers/gt';
import { createApp, h } from 'vue';
import './views/main';
import AutoLinks from 'quill-auto-links';
import './plugins/vueWebix/vue-view';
// import './plugins/vueWebix/webix-controls';
import QuillMention from 'quill-mention';
import ImageUploader from 'quill-image-uploader';
import app from '$$app';
import router from './router/main';
import store from '$$globalStore';
import App from './App.vue';
import { initVgpVueComponents } from './vgpVueComponents';
import vuetify from './plugins/vuetify';
import Quill from './libs/quill/ext';

import renderPublicPasswordPage from './views/publicUrl/renderPublicPasswordPage';
import rights from './components/rights/index';
import plansModel from './models/plans';

import './helpers/cookieConsent';
import userExtAnalytics from './helpers/userExtAnalytics';

window.webix_strict = true;
window.userExtAnalytics = userExtAnalytics;
window.dataLayer = window.dataLayer || [];
Quill.register('modules/autoLinks', AutoLinks);
Quill.register('modules/customMention', QuillMention);
Quill.register('modules/imageUploader', ImageUploader);

try {
  // Set Vue Router for BugsnagPerformance integration
  window.userExtAnalytics.setRouter(router);
  window.userExtAnalytics.init();
  window.userExtAnalytics.log('load');
  if (!plansModel.isTrial()) {
    window.userExtAnalytics.log('load_by_paid_user'); // required for google analytics
  }
  // window.userExtAnalytics.log('focus');
  // window.addEventListener('focus', () => {
  //   window.userExtAnalytics.log('focus');
  // });
} catch (e) {
  // console.error('External services init fail', e);
}

const bodyRows = [
  {
    view: 'vue',
    id: 'header',
    css: 'js_header',
    template: '<header-vue></header-vue>',
    data: {
      height: 1, // for start watching
    },
  },
  {
    borderless: true,
    paddingY: 0,
    margin: 0,
    body: {
      id: 'ganttMainNode',
      css: 'body-inner ganttMainNode',
      borderless: true,
      rows: [
        {
          type: 'wide',
          id: 'mainSpace',
          borderless: true,
          cols: [
            {
              view: 'dhx-gantt',
              id: 'dhxView-gantt',
              borderless: true,
              initMode: true,
            },
          ],
        },
      ],
    },
  },
];

if (app.config.mode.isExport || app.config.mode.isHistory) {
  bodyRows.shift();
}

const layout = {
  id: 'mainApplication',
  css: app.config.mode.isHistory ? 'isHistory' : '',
  cols: [
    {
      view: 'vue',
      id: 'leftSideBar',
      css: 'left-sidebar-wrapper',
      hidden: !app.config.mode.isBase,
      width: 40,
      // zIndex: 124,
      template: '<left-sidebar-vue> </left-sidebar-vue>',
    },
    {
      rows: [
        {
          id: 'ganttProBody',
          paddingY: 0,
          margin: 0,
          css: 'gantt_pro_body_container',
          borderless: true,
          rows: bodyRows,
        },
      ],
    },
  ],
};

if (!app.config.mode.isLink
  || app.config.mode.isHistory
  || app.config.mode.isTemplate
  || (app.config.mode.isLink && app.config.mode.accessToPublicUrl)
) {
  webix.ready(() => {
    app.trigger('app:start');
    webix.ui(layout);
    webix.Touch.limit();
    webix.extend($$('mainApplication'), webix.ProgressBar);
    $$('webix:debugmenu').close(); // fix right click+ctrl in debug version
  });
}

app.on('gantt:init:after', () => {
  const mainApplication = $$('mainApplication');

  if (mainApplication) {
    $$('mainApplication').hideProgress();

    // #paymentDataPlan user.subscription.status_code === 110
    if (plansModel.isOrderProcessing() && rights.account.isOwner()) {
      app.trigger('notify:payment:orderProcessing');
    }
  }
});

// Vue.config.devtools = true;
// Vue.config.productionTip = false;
const initVueApp = app => // it needs for init after load main models(temporary)
  new Promise((resolve, reject) => {
    const vueApp = createApp({
      // router,
      // store,
      // vuetify,
      components: {
        App,
      },
      watch: {
        $route(value) {
          app.trigger('app:route:changed', value);
        },
      },
      mounted() {
        resolve();
      },
      render() {
        return h(App);
      },
    });

    vueApp.config.compilerOptions.whitespace = 'condense';

    vueApp.use(router);
    vueApp.use(store);
    vueApp.use(vuetify);
    initVgpVueComponents(vueApp);
    vueApp.mount('#vue-container');
  });

if (app.config.mode.isLink
  && !app.config.mode.isHistory
  && !app.config.mode.isTemplate
  && !app.config.mode.accessToPublicUrl) {
  renderPublicPasswordPage(createApp);
}

// configureCompat({
//   // This restores Vue 2 behavior
//   ATTR_FALSE_VALUE: false,
//   RENDER_FUNCTION: false,
//   WATCH_ARRAY: false,
// });

export {
  initVueApp,
};
